import {
  bulkSocialPosts,
  createSocialPost,
  getAdminV1OrgProductsIdMedia,
  getSocialPost,
  listSocialPosts,
  listSocialTargets,
  publishSocialPost,
  removeSocialPost,
  unscheduleSocialPost,
  updateSocialPost,
  type BulkSocialPostsRequest,
  type CreateSocialPostRequest,
  type ListSocialPostsParams,
  type ProductMediaItem,
  type PublishSocialPostRequest,
  type SocialBulkResult,
  type SocialPost,
  type SocialPostList,
  type SocialProvider,
  type SocialTargetList,
  type UpdateSocialPostRequest,
} from '@nucleus-commerce/api-client/admin';

/** Posts of one store: the list, one post's lifecycle, the live board list and bulk actions. */
export const socialPostsApi = {
  list: (storeId: string, params: ListSocialPostsParams): Promise<SocialPostList> =>
    listSocialPosts({ storeId }, params),
  get: (storeId: string, id: string): Promise<SocialPost> => getSocialPost({ storeId, id }),
  create: (storeId: string, body: CreateSocialPostRequest): Promise<SocialPost> =>
    createSocialPost({ storeId }, body),
  update: (storeId: string, id: string, body: UpdateSocialPostRequest): Promise<SocialPost> =>
    updateSocialPost({ storeId, id }, body),
  /** The row stays as `removed`; `removeFromProvider` also deletes a published post on the network. */
  remove: (storeId: string, id: string, removeFromProvider: boolean): Promise<void> =>
    removeSocialPost({ storeId, id }, removeFromProvider ? { removeFromProvider } : {}),
  /** Without `publishAt` the post goes out on the next minute sweep. */
  publish: (storeId: string, id: string, body: PublishSocialPostRequest): Promise<SocialPost> =>
    publishSocialPost({ storeId, id }, body.publishAt ? body : null),
  unschedule: (storeId: string, id: string): Promise<SocialPost> =>
    unscheduleSocialPost({ storeId, id }),
  bulk: (storeId: string, body: BulkSocialPostsRequest): Promise<SocialBulkResult> =>
    bulkSocialPosts({ storeId }, body),

  /** Boards read live from the network; needs a live connection (409 otherwise). */
  targets: (storeId: string, provider: SocialProvider): Promise<SocialTargetList> =>
    listSocialTargets({ storeId, provider }),

  /** The master product's gallery, where the editor picks the post's images from. */
  productMedia: (productId: string): Promise<ProductMediaItem[]> =>
    getAdminV1OrgProductsIdMedia({ id: productId }).then((r) => r.items),
};
